/*
 * Copyright (C) 2021 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PillModule } from '../pill.module';
import { ResponsivePillListComponent } from './responsive-pill-list.component';
import { ResponsivePillDirective } from './responsive-pill.directive';
import { ShadowResponsivePillListComponent } from './shadow-responsive-pill-list/shadow-responsive-pill-list.component';


@NgModule({
  declarations: [
    ResponsivePillDirective,
    ResponsivePillListComponent,
    ShadowResponsivePillListComponent,
  ],
  imports: [
    CommonModule,
    PillModule
  ],
  exports: [
    ResponsivePillDirective,
    ResponsivePillListComponent,
  ]
})
export class ResponsivePillListModule {
}
